<template>
  <div>
    <div class="bank-logo d-flex justify-content-around">
      <div class="logo-div" v-bind:class="{'active': selectedMethod == true_money}" v-if="!disablePayments.includes(true_money)">
        <b-img
          @click="changePaymentMethod(true_money)"
          src="/images/trueMoney.png"
          class="logo-item"
          :alt="$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})"
        ></b-img>
        <CheckboxMarkedCircleIcon v-if="selectedMethod == true_money" />
      </div>
      <div class="logo-div" v-bind:class="{'active': selectedMethod == bill_payment}" v-if="!disablePayments.includes(bill_payment)">
        <b-img
          @click="changePaymentMethod(bill_payment)"
          src="/images/tescoLotus.png"
          class="logo-item"
          :alt="$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})"
        ></b-img>
        <CheckboxMarkedCircleIcon v-if="selectedMethod == bill_payment" />
      </div>
      <div class="logo-div" v-bind:class="{'active': selectedMethod == prompt_pay}" v-if="!disablePayments.includes(prompt_pay)">
        <b-img
          @click="changePaymentMethod(prompt_pay)"
          src="/images/promptPay.png"
          class="logo-item" style="width:111px;"
          :alt="$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})"
        ></b-img>
        <CheckboxMarkedCircleIcon v-if="selectedMethod == prompt_pay" />
      </div>
    </div>
    <TrueMoney
      v-if="selectedMethod == true_money"
      :orderId="orderId"
      :formattedAmount="formattedAmount"
      :changeLoading="changeLoading"
      :previousPendingPaymentId="previousPendingPaymentId"
    />
    <CounterBill
      v-if="selectedMethod == bill_payment"
      :orderId="orderId"
      :formattedAmount="formattedAmount"
      :changeLoading="changeLoading"
      :previousPendingPaymentId="previousPendingPaymentId"
    />
    <PromptPay
      v-if="selectedMethod == prompt_pay"
      :orderId="orderId"
      :formattedAmount="formattedAmount"
      :changeLoading="changeLoading"
      :previousPendingPaymentId="previousPendingPaymentId"
      :showQrDialog="true"
    />
  </div>
</template>
<script>
import $ from "jquery";
import { mapActions, mapState } from "vuex";
import CounterBill from "@/components/paymentMethods/others/counterBill";
import PromptPay from "@/components/paymentMethods/others/promptPay";
import TrueMoney from "@/components/paymentMethods/others/trueMoney";
import * as actionType from "../../../controllers/ActionTypes";
import CheckboxMarkedCircleIcon from "vue-material-design-icons/CheckboxMarkedCircle.vue";

export default {
  name: "others",
  components: {
    CounterBill,
    PromptPay,
    TrueMoney,
    CheckboxMarkedCircleIcon
  },
  props: {
    formattedAmount: {
      type: String,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    changeLoading: {
      type: Function,
      required: true
    },
    previousPendingPaymentId: {
      required: false,
      default: null
    },
    updatePaymentMethod: {
      required: true,
      type: Function
    },
    preSelectedMethod: {
      required: true,
      type: Number
    },
    disablePayments:{
      required:true,
      type: Array
    }
  },
  data() {
    return {
      loading: false,
      selectedMethod: null
    };
  },
  computed: {
    ...mapState("PaymentController", [
      "bill_payment",
      "true_money",
      "prompt_pay"
    ])
  },
  watch: {
    loading: function() {
      this.changeLoading(this.loading);
    }
  },
  methods: {
    ...mapActions("PaymentController", [actionType.PAY]),
    changePaymentMethod(paymentMethod) {
      this.selectedMethod = paymentMethod;
      this.updatePaymentMethod(paymentMethod);
    },
    hasStartedGeneration() {
      this.loading = true;
    },
    hasGenerated() {
      this.loading = false;
    }
  },
  mounted() {
    this.selectedMethod = this.preSelectedMethod;
  }
};
</script>
<style lang="scss" scoped>
.counterbill {
  background: #ffffff 0% 0% no-repeat padding-box;
  margin: 50px;
}
.logo {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: center;
}
​ .logoimg {
  width: 300px;
  height: 234px;
}
.rightcontent {
  font-size: 65px;
  width: 455px;
  border-bottom: 3px solid var(--projectPrimaryColor) !important;
  text-align: right;
  padding: 20px 0;
}
​ .toptext {
  color: #444444;
}
.secondrow {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: flex-start;
  margin-top: 12px;
}
​ .address {
  width: 400px;
  font-size: 22px;
}
.boldaddress {
  color: #444444;
  font-weight: bold;
}
.secondrightcontent {
  width: 450px;
  font-size: 20px;
}
​ .secondrightcontentdiv {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: flex-start;
}
.thirdrow {
  border-bottom: 3px solid var(--projectPrimaryColor) !important;
  color: #444444;
  font-weight: bold;
  margin-top: 65px;
  font-size: 32px;
  padding-bottom: 20px;
  ​margin-bottom: 50px;
}
.fourthrow {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: flex-start;
  margin-bottom: 20px;
}
.fourthrighttext {
  width: 240px;
  color: #444444;
  font-weight: bold;
  font-size: 24px;
}
.fourthlefttext {
  color: #444444;
  margin-left: 20px;
  font-size: 24px;
  word-break: break-word;
}
​ .package {
  border-bottom: 3px solid var(--projectPrimaryColor) !important;
  color: #444444;
  font-weight: bold;
  margin-top: 65px;
  font-size: 32px;
  padding-bottom: 20px;
  ​margin-bottom: 50px;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: flex-start;
}
​ .firstlable {
  width: 200px;
}
.secondlable {
  width: 300px;
}
.package-div {
  margin-top: 20px;
  font-size: 24px;
  padding-bottom: 20px;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: flex-start;
}
​ .package-div-firstlable {
  width: 200px;
  padding-left: 30px;
}
​ .package-div-secondlable {
  width: 300px;
  text-align: left;
}
​ .total {
  border-top: 3px solid var(--projectPrimaryColor) !important;
  color: #444444;
  font-weight: bold;
  font-size: 32px;
  padding-bottom: 20px;
  ​margin-bottom: 50px;
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: flex-start;
}
.total-div {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: flex-start;
  width: 100%;
  padding-top: 20px;
}
​ .total-div-label {
  padding-left: 30px;
}
.total-div-price {
  width: 300px;
  text-align: left;
}
​ .total-amount {
  height: 100px;
  background: var(--projectPrimaryColor) 0% 0% no-repeat padding-box !important ;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: center;
  font-size: 32px;
  color: white;
}
​ .total-amount-label {
  padding-left: 30px;
}
.total-amount-price {
  width: 300px;
  text-align: left;
}
​ .footer-logo {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: center;
  margin: 20px;
}
​ .tesco-logo {
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: center;
  align-items: center;
  font-size: 32px;
}
​ .tescoimage {
  width: 200px;
  margin-top: 20px;
}
.qrimage {
  width: 500px;
  height: 200px;
}
​ .footer {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: flex-start;
  border-top: 3px solid var(--projectPrimaryColor) !important;
  padding-top: 20px;
}
​ .footer-text {
  font-size: 24px;
  margin-right: 50px;
}
.bank-logo {
  margin-bottom: 30px;
  > .logo-div {
    border: 1px solid #cbcbcb;
    border-radius: 5px;
    width: 120px;
    height: 80px;
    position: relative;
    .checkbox-marked-circle-icon {
      color: var(--projectPrimaryColor) !important;
      position: absolute;
      bottom: 5px;
      right: 5px;
    }
    .logo-item {
      width: 73px;
      height: 73px;
    }

    &:hover {
      cursor: pointer;
    }
    &.active {
      border: 1px solid var(--projectPrimaryColor) !important;
      border-radius: 5px;
      box-shadow: 0px 3px 6px #00000029;
    }
  }
}
</style>